<template>
  <div class="chartsData" ref="chartsData"></div>
</template>

<script>
export default {
    name:'Histogram',
    methods:{
        getCharts(){
            this.chartsData = this.$echarts.init(this.$refs.chartsData);
            let option = {
                tooltip: {
                    trigger: 'item'
                },
                xAxis: {
                    type: 'value',
                    axisLabel: {
                        show: true,
                        textStyle: {
                            color: '#fff',  //更改坐标轴文字颜色
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: "rgba(0, 192, 255, 1)"
                        }
                    },
                    axisLine: {
                        show:false
                    }
                },
                yAxis: {
                    type: 'category',
                    data: ['审核未通过', '审核通过', '派工完成', '维修完成', '评价完成', '未完工', '已到位'],
                    axisLabel: {
                        show: true,
                        textStyle: {
                            color: '#fff',  //更改坐标轴文字颜色
                        },
                    },
                    axisLine: {
                        lineStyle: {
                            color: "rgba(0, 192, 255, 1)"
                        }
                    }
                },
                series: [{
                    data: [120, 200, 150, 80, 70, 110, 130],
                    type: 'bar',
                    barCategoryGap: "70%", //柱子之间间距
                    itemStyle: {
                        normal:{
                            borderRadius: [0, 2, 2, 0],
                            barWidth:'10px',
                            color: new this.$echarts.graphic.LinearGradient(
                                0, 0, 1, 0,
                                [
                                    {offset: 0, color: '#00C0FF'},
                                    {offset: 1, color: '#02EAF3'}
                                ]
                            )
                        }
                    },
                }]
            };
            this.chartsData.setOption(option);
        }
    },
    mounted(){
        this.getCharts()
    }
}
</script>

<style langg='scss' scoped>
.chartsData{
    width: 100%;
    height: 400px;
}
</style>